<template>
  <el-select
    style="width : 100%"
    v-model="selected"
    @change="$emit('input', selected)"
    filterable
    remote
    reserve-keyword
    :placeholder="placeholder"
    :remote-method="handleSearch"
    :loading="isLoading"
    clearable
    :value-key="primaryKey"
    :value="initialValue"
  >
    <el-option
      v-for="item in list"
      :label="item[label]"
      :key="item[primaryKey]"
      :value=" objectReturn ? item : item[primaryKey]"
    >
      <slot v-bind:item="item"></slot>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    initialValue: {
      type: Object,
      default: function () {
        return {}
      }
    },
    placeholder: String,
    primaryKey: String,
    urlSearch: String,
    label: String,
    objectReturn: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data() {
    return {
      selected: this.initialValue[this.primaryKey],
      isLoading: false,
      list: [{ ...this.initialValue }]
    }
  },
  methods: {
    async handleSearch(query) {
      this.isLoading = true;
      const { data } = await axios.get(
        this.urlSearch,
        { params: { query } }
      );
      this.list = [...data];
      this.isLoading = false;
    }
  }
}
</script>

<style>
</style>
